/**
 * Created by sivanh on 17/06/2018.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var Button = require("ui/button/Button");

    var ScheduleShiftItemView = require("manager-views/schedule/ScheduleShiftItemView");
    var template = require("manager-templates/schedule/scheduleShiftsListView.tmpl");

    var ScheduleShiftsListView = {};
    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ScheduleShiftsListView = Marionette.CompositeView.extend({
            itemViewContainer: '.shifts-container',
            template: template,
            itemView: ScheduleShiftItemView,
            ui: {
                shiftsContainer: ".shifts-container",
                addMoreButtonContainer: ".schedule-shifts-add-more-button"
            },
            uiComponents: {
                addMoreShiftButton: {
                    type: Button,
                    options: {
                        el: "view.ui.addMoreButtonContainer",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_addNewShift"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function () {
                this._onRender();
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.container = options.container;
                this.scheduleEventModel = options.scheduleEventModel;
                this.itemViewOptions = {channel: options.channel};
            },

            _onRender: function() {
                if (this.container) {
                    this.container.append(this.$el);
                }
                this._manageSingleItemState();
                this._bindEvents();
            },

            _bindEvents: function () {
                this.listenTo(this.collection, "add", this._manageSingleItemState);
                this.listenTo(this.collection, "remove", this._manageSingleItemState);
                this.listenTo(this, "itemview:remove:shift:clicked", this._onShiftRemoveClicked);
            },

            //sets the class "single-item" when 'x' should not be displayed, and removes it otherwise
            _manageSingleItemState: function () {
                var singleItem = this.collection.size() === 1;
                this.ui.shiftsContainer.toggleClass("single-item", singleItem);
            },

            _addNewShift: function () {
                this.channel.trigger("ScheduleShiftsList:change:shiftsCollection:add", this.scheduleEventModel);
            },

            _onShiftRemoveClicked: function (shiftItemView, shiftModel) {
                if(this.collection.size() > 1) {
                    this.channel.trigger("ScheduleShiftsList:change:shiftsCollection:remove", this.scheduleEventModel, shiftModel);
                }
            }

        });
    }

    LE.module("LEManager", moduleDefinition);

    return ScheduleShiftsListView;
});

